import PopupBasicLazy from 'src/game/components/popups/PopupBasicLazy';
import i18n from 'src/lib/i18n/i18n';
import uiConfig from 'src/lib/ui/config';
import View from '@play-co/timestep-core/lib/ui/View';
import sounds from 'src/lib/sounds';
import TabbedView from '../../components/shared/tabs/TabbedView';
import { Feature } from 'src/replicant/analytics';
import { AssetGroup } from '@play-co/timestep-core';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import { FriendSearchTab } from '../components/FriendSearchTab';
import { FriendRequestTab } from '../components/FriendRequestTab';
import FriendshipRequestsBadge from '../FriendshipRequestsBadge';

type CloseHandler = () => void;

export default class PopupFriends extends PopupBasicLazy {
  private tabs: TabbedView;
  private search: FriendSearchTab;
  private requests: FriendRequestTab;

  constructor(opts: { superview: View; close: CloseHandler }) {
    super({
      zIndex: 10000,
      width: uiConfig.popups.buruburu.width,
      height: 897,
      darkerBg: false,
      titleIcon: { image: 'assets/ui/friends/friend_referral_icon.png' },
      superview: opts.superview,
      close: opts.close,
      tracking: {
        feature: Feature.FRIENDS._,
        $subFeature: Feature.FRIENDS.POPUP,
      },
    });

    this.buttonClose.removeFromSuperview();

    this.tabs = new TabbedView({
      tabsFillWidth: true,
      tabs: [
        {
          label: () => i18n('friends.search'),
          tracking: {
            feature: Feature.FRIENDS._,
            $subFeature: Feature.FRIENDS.TAB_SEARCH,
          },
          onSelect: () => this.selectTab('search'),
        },
        {
          label: () => i18n('friends.requests'),
          tracking: {
            feature: Feature.FRIENDS._,
            $subFeature: Feature.FRIENDS.TAB_REQUESTS,
          },
          onSelect: () => this.selectTab('requests'),
        },
      ],
      alignment: 'left',
      superview: this.box,
      rect: {
        x: 30,
        y: 150,
        width: this.box.style.width - 60,
        height: 590,
      },
    });

    const [searchTab, requestsTab] = this.tabs.getViews();
    this.search = new FriendSearchTab(searchTab);
    this.requests = new FriendRequestTab(requestsTab);

    const [searchButton, requestButton] = this.tabs.getTabs();
    this.createRequestTabBadge(requestButton.getView());

    // Close button
    new ButtonScaleViewWithText({
      superview: this.box,
      ...uiConfig.buttons.cancel,
      labelOffsetY: -1,
      fontSize: 46,
      font: 'Body',
      x: this.box.style.width / 2,
      y: this.box.style.height - 85,
      width: 259,
      height: 100,
      centerOnOrigin: true,
      localeText: () => i18n('basic.close'),
      onClick: async () => {
        sounds.sfx.play('cancel');
        opts.close();
      },
      tracking: {
        feature: Feature.FRIENDS._,
        $subFeature: Feature.FRIENDS.POPUP_CLOSE,
      },
    });
  }

  public getAssetsGroup() {
    return new AssetGroup(['assets/ui/friends/friend_referral_icon.png']);
  }

  public init(opts: { tab?: 'search' | 'requests' }) {
    super.init({
      title: i18n('friends.title'),
      message: '',
    });
    this.selectTab(opts.tab || 'search');
  }

  private selectTab(tab: 'search' | 'requests') {
    if (tab === 'search') {
      this.search.refresh();
      this.tabs.setProps({ selectedTabIndex: 0 });
    }

    if (tab === 'requests') {
      this.tabs.setProps({ selectedTabIndex: 1 });
      this.requests.refresh();
    }
  }

  private createRequestTabBadge(superview: View) {
    new FriendshipRequestsBadge({
      superview,
      size: 40,
      x: superview.style.width - 50,
      y: -12,
      font: 'Body',
      fontSize: 18,
      textColor: 'white',
      style: 'red',
    });
  }
}
